/**
 * @generated SignedSource<<b6a5a341a914fe51a650af383283e3c4>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainVirtualAgentSidebarQuery$variables = {
  checkForAiEnabledFF: boolean;
  cloudId: string;
  key: string;
};
export type mainVirtualAgentSidebarQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly virtualAgentConfiguration: {
        readonly __typename: string;
        readonly " $fragmentSpreads": FragmentRefs<"nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentConfigurationRef">;
      } | null | undefined;
    };
  };
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly isAiEnabledInAdminHub?: boolean | null | undefined;
      readonly isVirtualAgentAvailable: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef">;
    } | null | undefined;
  } | null | undefined;
};
export type mainVirtualAgentSidebarQuery = {
  response: mainVirtualAgentSidebarQuery$data;
  variables: mainVirtualAgentSidebarQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkForAiEnabledFF"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  (v3/*: any*/)
],
v7 = [
  {
    "kind": "ScalarField",
    "name": "isAiEnabledInAdminHub"
  }
],
v8 = {
  "condition": "checkForAiEnabledFF",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v7/*: any*/)
},
v9 = {
  "kind": "ScalarField",
  "name": "isVirtualAgentAvailable"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainVirtualAgentSidebarQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "virtualAgentConfiguration",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentConfigurationRef"
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "VirtualAgentFeatures",
            "kind": "LinkedField",
            "name": "virtualAgentEntitlements",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef"
              },
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "mainVirtualAgentSidebarQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "VirtualAgentQueryError"
                  }
                ]
              },
              (v10/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "VirtualAgentFeatures",
            "kind": "LinkedField",
            "name": "virtualAgentEntitlements",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v7/*: any*/)
              },
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
    "metadata": {},
    "name": "mainVirtualAgentSidebarQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};
})();

(node as any).hash = "cfd46162843f2acc60da5ab6493725c3";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
